module.exports = require("vm");;